import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { organisationUserBlockUnblockSchema } from "@backend/src/schemas/organisationSchema";

export type OperatorStatusApiResponse = ResponseType<null>;
function useUserStatusMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OperatorStatusApiResponse>["response"],
    AxiosResponseAndError<OperatorStatusApiResponse>["error"],
    z.infer<typeof organisationUserBlockUnblockSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.put<OperatorStatusApiResponse>(
        requestURLs.organisation + "/organisationUserBlockUnblock",
        data
      ),
  });
  return mutation;
}
export default useUserStatusMutation;
